import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { OrderHistoryPageComponentService, OrderListTypes } from '../order-history-page.component-service';

@Component({
  selector: 'sd-order-history-filter',
  imports: [SdvorButtonComponent],
  templateUrl: './order-history-filter.component.html',
  styleUrl: './order-history-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderHistoryFilterComponent {
  private readonly orderHistoryPageComponentService = inject(OrderHistoryPageComponentService);
  private readonly deviceService = inject(DeviceService);

  isTabletDown = toSignal(this.deviceService.isMobileSmDown$);
  orderListTypes = OrderListTypes;
  orderListType = computed(() => this.orderHistoryPageComponentService.orderListType());

  setOrderListType(value: OrderListTypes): void {
    this.orderHistoryPageComponentService.setOrderListType(value);
  }
}
